import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
import { preFixZero } from '../../utils/index';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

/**
 * Swiper
 * Doc: https://swiperjs.com/swiper-api
 */
export const heroSlider = () => {
  new Swiper('.js-hero-banner-swiper', {
    // Optional parameters
    // direction: 'vertical',
    // loop: true,
    effect: 'fade',
    pagination: {
      el: '.js-hero-banner-swiper-pagination',
      clickable: true,
      renderBullet: function(index, className) {
        return `<span class="${className}">${preFixZero(index + 1)}</span>`;
      },
    },
  });
};

/**
 * Existing JS from Space Furniture
 * Existing Comment: journal image swiper
 */
export const relatedArticleSlider = () => {
  new Swiper('[data-article-image-swiper]', {
    slidesPerView: 'auto',
    spaceBetween: 12,
    slidesOffsetBefore: 12,
    centerInsufficientSlides: true,
    updateOnWindowResize: true,
    updateOnImagesReady: true,
    observer: true,
    observeSlideChildren: true,
    watchOverflow: true,
    pagination: {
      el: '[data-article-image-swiper-pagination]',
      clickable: true,
    },
    slidesOffsetAfter: 12,
    on: {
      imagesReady: function() {
        $('[data-swiper-image]').each(function() {
          $(this)
            .closest('.swiper-slide')
            .width($(this).width());
        });
      },
      resize: function() {
        $('[data-swiper-image]').each(function() {
          $(this)
            .closest('.swiper-slide')
            .width($(this).width());
        });

        //set first slide to be in line with text on larger viewports
        if (window.innerWidth > 1400) {
          this.params.slidesOffsetBefore =
            window.innerWidth / 2 - $('.page-width--narrow').outerWidth() / 2;
          this.update();
        }
      },
      init: function() {
        //hide pagination if the slides are less than the page width
        if (
          $('.article__image-swiper').outerWidth() >=
          $('.article__image-swiper .swiper-wrapper').get()[0].scrollWidth
        ) {
          $('.article__image-swiper-pagination').hide();
        }

        //set first slide to be in line with text on larger viewports
        if (window.innerWidth > 1400) {
          this.params.slidesOffsetBefore =
            window.innerWidth / 2 - $('.page-width--narrow').outerWidth() / 2;
          this.update();
        }
      },
    },
  });
};

/**
 * Existing JS from Space Furniture
 * Selector is located on page.journal.liquid , Based on Polifom designs, this may not be required...
 * Existing comment: journal swiper mobile only (for the journal landing page)
 */
export const relatedMobileArticleSlider = () => {
  let breakpoint = window.matchMedia('(min-width:990px)');
  let mySwiper;

  const breakpointChecker = function() {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) mySwiper.destroy(true, true);
      return;
    } else if (breakpoint.matches === false) {
      return enableSwiper();
    }
  };

  const enableSwiper = function() {
    mySwiper = new Swiper('[data-journal-swiper-mobile]', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
    });
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
};
